var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUserContext } from '@web/contexts/User';
import { useGTMPageTracking } from '@web/lib/gtm';
import { AppsView } from '@web/pages/Apps';
import { AuthCallbackPage } from '@web/pages/AuthCallbackPage';
import { DashboardView } from '@web/pages/Dashboard';
import { DocAlertsView } from '@web/pages/DocAlerts';
import { InstallationView } from '@web/pages/Installation';
import { ItemDetailsView } from '@web/pages/ItemDetails';
import NotFoundView from '@web/pages/layout/NotFoundView/NotFoundView';
import { OnboardingView } from '@web/pages/Onboarding';
import { PerformanceInsightsView } from '@web/pages/PerformanceInsights';
import { PostInstallView } from '@web/pages/PostInstall';
import { ProfileView } from '@web/pages/Profile';
import SettingsView from '@web/pages/Settings';
import { SignInView } from '@web/pages/SignIn';
import { getUrl } from '@web/router/getUrl';
import { appsUrl, authGoogleCallbackUrl, dashboardUrl, docAlertsUrl, homeUrl, installationUrl, itemDetailsUrl, onboardingUrl, performanceInsightsUrl, postInstallUrl, profileUrl, settingsUrl, signInUrl } from '@web/router/urls';
import { AuthorizationRequiredRoute, InstalledAppRequiredRoute, NoAutharizationRoute, PostInstallRoute } from '@web/router/Wrappers';
import { Route, Routes } from 'react-router-dom';
export var appRoutesList = [
    {
        url: homeUrl,
        ViewComponent: DashboardView,
        WrapperComponent: InstalledAppRequiredRoute
    },
    {
        url: signInUrl,
        ViewComponent: SignInView,
        WrapperComponent: NoAutharizationRoute
    },
    {
        url: postInstallUrl,
        ViewComponent: PostInstallView,
        WrapperComponent: PostInstallRoute
    },
    {
        url: dashboardUrl,
        ViewComponent: DashboardView,
        WrapperComponent: InstalledAppRequiredRoute
    },
    {
        url: performanceInsightsUrl,
        ViewComponent: PerformanceInsightsView,
        WrapperComponent: InstalledAppRequiredRoute
    },
    {
        url: getUrl(appsUrl),
        ViewComponent: AppsView,
        WrapperComponent: InstalledAppRequiredRoute
    },
    {
        url: installationUrl,
        ViewComponent: InstallationView,
        WrapperComponent: AuthorizationRequiredRoute
    },
    {
        url: getUrl(settingsUrl),
        ViewComponent: SettingsView,
        WrapperComponent: InstalledAppRequiredRoute
    },
    {
        url: profileUrl,
        ViewComponent: ProfileView,
        WrapperComponent: InstalledAppRequiredRoute
    },
    {
        url: getUrl(docAlertsUrl),
        ViewComponent: DocAlertsView,
        WrapperComponent: InstalledAppRequiredRoute
    },
    {
        url: onboardingUrl,
        ViewComponent: OnboardingView,
        WrapperComponent: AuthorizationRequiredRoute
    },
    {
        url: itemDetailsUrl,
        ViewComponent: ItemDetailsView,
        WrapperComponent: InstalledAppRequiredRoute
    }
];
export function AppRouter() {
    var currentUser = useUserContext().currentUser;
    useGTMPageTracking();
    return (_jsxs(Routes, { children: [_jsx(Route, { path: authGoogleCallbackUrl, element: _jsx(AuthCallbackPage, {}) }), appRoutesList.map(function (_a) {
                var url = _a.url, ViewComponent = _a.ViewComponent, WrapperComponent = _a.WrapperComponent;
                return (_jsx(Route, { path: url, element: _jsx(WrapperComponent, __assign({ user: currentUser }, { children: _jsx(ViewComponent, {}) })) }, url));
            }), _jsx(Route, { path: "*", element: _jsx(NotFoundView, {}) })] }));
}
export default AppRouter;
